import { useMemo } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { DatePicker } from "@mui/x-date-pickers"
import { DATE } from "helpers/shapes"
import { DEFAULT_PROPS, DEFAULT_SLOT_PROPS } from "helpers/date-picker"
import "./style.scss"

const LATEST_DATE = moment().add(5, "year").endOf("year")
const EARLIEST_DATE = moment("1990-01-01")

export default function DateFormPicker({ label, helperText, selectedDate, onChange, onError, onBlur, earliestDate, latestDate, clearable, keepMoment, shouldDisableDate }) {
  const [selectedMomentDate, minDate, maxDate] = useMemo(
    () => [
      selectedDate ? moment(selectedDate) : null,
      earliestDate ? moment(earliestDate) : EARLIEST_DATE,
      latestDate ? moment(latestDate) : LATEST_DATE,
    ], [selectedDate, earliestDate, latestDate])

  const handleOnChange = (date, { validationError }) => {
    if (keepMoment) {
      onChange(date)
    } else if (validationError && onError) {
      onError()
    } else if (date) {
      onChange(date.format("YYYY-MM-DD"))
    } else {
      onChange(null)
    }
  }

  return <DatePicker
    className="components_date-form-picker"
    {...DEFAULT_PROPS}
    value={selectedMomentDate}
    onChange={handleOnChange}
    label={label}
    minDate={minDate}
    maxDate={maxDate}
    shouldDisableDate={shouldDisableDate}
    slotProps={{
      ...DEFAULT_SLOT_PROPS,
      field: {
        clearable,
      },
      textField: {
        variant: "standard",
        onBlur,
        helperText,
      },
      openPickerButton: {
        "data-test-class": "CalendarIcon",
      },
    }}
  />
}

DateFormPicker.propTypes = {
  selectedDate: DATE,
  latestDate: PropTypes.string,
  earliestDate: PropTypes.string,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  clearable: PropTypes.bool,
  keepMoment: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onBlur: PropTypes.func,
  shouldDisableDate: PropTypes.func,
}
